<script setup lang="ts">
import { toTypedSchema } from '@vee-validate/valibot';
import { ContactSellerFormSchema, type ContactSellerForm } from '@@/shared/contact/types';
import type { AddressRetrieve } from '@@/shared/address/types';
import type { PartialDeep } from 'type-fest';

defineProps<{
  id: string
}>();

const emit = defineEmits<{
  'update:form': [form: ContactSellerForm]
}>();
const { t, locale } = useI18n();
const { m } = useIadFormat();

const initialValues: PartialDeep<ContactSellerForm> = {
  address: undefined,
  project: 'sell',
  locale: locale.value,
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  adSubscription: false,
  adPartnerSubscription: false,
};
const { handleSubmit, resetForm } = useForm({
  initialValues,
  validationSchema: toTypedSchema(ContactSellerFormSchema),
});

const { value: address, errorMessage: errorMessageAddress } = useField<AddressRetrieve>(`address`);
const errorAddress = computed(() => errorMessageAddress.value ? t(errorMessageAddress.value) : undefined);
const { notifyError } = useNotifications();

const displayMessageArea = ref(false);
const onSubmit = handleSubmit((values: ContactSellerForm) => {
  emit(`update:form`, values);
  displayMessageArea.value = false;
  resetForm();
}, () => {
  notifyError(t('core.form.error.enter_mandatory_fields'));
});
</script>

<template>
  <form
    :id
    novalidate
    autocomplete="off"
    @submit="onSubmit"
  >
    <div>
      <IadInputAddress
        v-model="address"
        :placeholder="$t(`core.location.input_address_placeholder`)"
        :label="m(`agent.form.project_location`)"
        :error="errorAddress"
      />
      <AgentContactInfoFields
        :id
        variant="sale"
      />
    </div>
  </form>
</template>
